import { AlertOctagon, AlertTriangle, Info, CircleAlert } from 'lucide-react';
import type { ReactNode } from 'react';

export type Severity = 'critical' | 'high' | 'medium' | 'info';

/**
 * Severity is conveyed by icon + shape + text, never colour alone (a11y).
 */
const MAP: Record<Severity, { label: string; cls: string; icon: ReactNode }> = {
  critical: { label: 'Critical', cls: 'text-crit border-crit/40 bg-crit/10', icon: <AlertOctagon size={13} /> },
  high: { label: 'High', cls: 'text-high border-high/40 bg-high/10', icon: <AlertTriangle size={13} /> },
  medium: { label: 'Medium', cls: 'text-med border-med/40 bg-med/10', icon: <CircleAlert size={13} /> },
  info: { label: 'Info', cls: 'text-info border-info/40 bg-info/10', icon: <Info size={13} /> },
};

export function SeverityBadge({ severity }: { severity: Severity }) {
  const s = MAP[severity];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[11px] font-medium uppercase tracking-wide ${s.cls}`}
    >
      {s.icon}
      {s.label}
    </span>
  );
}
